module.exports = flarum.core.compat['components/LoadingIndicator'];